import { useEffect, useRef, useState } from 'react';

export const InputField = (
  { type,
    value,
    className,
    onChange,
    placeholder,
    name,
    id,
    lable,
    error,
    maxLength,
    accept,
    readOnly,
    minLength,
    required,
    pattern,
    max,
    min,
    ownClass,
    errorClass
  }
) => {
  const inputRef = useRef(null);
  useEffect(() => {
    if (value !== undefined) {
      inputRef.current.value = value;
    }
  }, [value]);


  return (
    <>
      <div className={ownClass ? ownClass : "mb-3"}>
        {lable ? <label htmlFor={id ? id : ''} className="form-label inputLable">{lable}</label> : ''}
        <input
          required={required ? true : false}
          readOnly={readOnly ? true : false}
          accept={accept}
          type={type}
          id={id}
          min={minLength ? minLength : ""}
          maxLength={maxLength ? maxLength : ""}
          max={max ? max : ''}
          name={name}
          className={className ? className : "form-control"}
          placeholder={placeholder ? placeholder : ""}
          ref={inputRef}
          onChange={onChange}
        />
        <small className={errorClass ? errorClass : "text-danger"}>{error}</small>
      </div>
    </>
  );
};
